import { myOptions } from "src/components/personel/userForm";
import Modal from "src/components/common/modal";
import { useMyStore } from "src/components/main/mainStore";
export default function FilterForm({
    closeIt, setCurrentPage,
    curFilter, setFilter, usersList,
    defaultFilter
}){
    const user = useMyStore(state => state.user);
    return (
        <Modal
            touchOutsideClose = {true}
            closeIt = {closeIt}
            title = "Filter"
            width = {650}
            maxWidth = {"100%"}
        >
            <div className = "m-3">
                <span className = "mr-3 font-weight-bold">Validity:</span>
                <select className = "form-control inline" value = {curFilter.void} onChange = {e => setFilter({...curFilter, void: e.currentTarget.value})}>
                    <option value = "0">Valid</option>
                    <option value = "1">Void</option>
                    <option>All</option>
                </select>
                {
                curFilter.void !== "0"?
                <span style = {{marginLeft: 10}} onClick = {() => {setFilter({...curFilter, void: "0"})}}>❌</span>:
                null
                }
            </div>
            {user.projects === "no"?null:<>
            <div className = "m-3">
                <span className = "mr-3 font-weight-bold">Requester:</span>
                <select className = "form-control inline" value = {curFilter.submitter} onChange = {e => {
                    setFilter({...curFilter, submitter: e.currentTarget.value.toLowerCase()});
                    setCurrentPage(1);
                }}>
                    <option value = "">Select</option>
                    {usersList.map((u, ui) => <option key = {ui} value = {u.email}>{u.userName}</option>)}
                </select>
                {
                curFilter.submitter !== ""?
                <span style = {{marginLeft: 10}} onClick = {() => {setFilter({...curFilter, submitter: ""})}}>❌</span>:
                null
                }
            </div>
            <div className = "m-3">
                <span className = "mr-3 font-weight-bold">Department:</span>
                <select className = "form-control inline" value = {curFilter.department} onChange = {e => {
                    setFilter({...curFilter, department: e.currentTarget.value});
                    setCurrentPage(1);
                }}>
                    <option value = "">Select</option>
                    {Object.entries(myOptions.department).map(([key, value], k) => <optgroup label = {key} key = {k}>{value.map((v, vi) => <option key = {vi}>{v}</option>)}</optgroup>)}
                </select>
                {
                curFilter.department !== ""?
                <span style = {{marginLeft: 10}} onClick = {() => {setFilter({...curFilter, department: ""})}}>❌</span>:
                null
                }
            </div>
            </>}
            <div className = "m-3">
                <span className = "mr-3 font-weight-bold">Request Date:</span>
                <input 
                    type = "date" 
                    min = "1900-01-01"
                    max = "2999-12-31"
                    className = "form-control" 
                    value = {curFilter.requestDate} 
                    onChange = {e => setFilter({
                        ...curFilter, 
                        requestDate: e.currentTarget.value
                    })}
                />
                {
                curFilter.requestDate?
                <span style = {{marginLeft: 10}} onClick = {() => {setFilter({...curFilter, requestDate: ""})}}>❌</span>:
                null
                }
            </div>
            <div className = "m-3">
                <span className = "mr-3 font-weight-bold">Total Hours:</span>
                <span className = "blk">
                    <span className = "mr-3">min:</span>
                    <input
                        type = "number"
                        className = "mr-3 form-control inline"
                        step = {2}
                        value = {curFilter.totalMin}
                        onChange = {e => {
                            setFilter({...curFilter, totalMin: e.currentTarget.value});
                            setCurrentPage(1);
                        }}
                    />
                </span>
                <span className = "blk">
                    <span className = "mr-3">max:</span>
                    <input
                        type = "number"
                        className = "form-control inline"
                        step = {2}
                        value = {curFilter.totalMax}
                        onChange = {e => {
                            setFilter({...curFilter, totalMax: e.currentTarget.value});
                            setCurrentPage(1);
                        }}
                        
                    />
                </span>
                {
                curFilter.totalMax || curFilter.totalMin?
                <span style = {{marginLeft: 10}} onClick = {() => {setFilter({...curFilter, totalMin: "", totalMax: ""})}}>❌</span>:
                null
                }
            </div>
            <div className = "m-3">
                <span className = "mr-3 font-weight-bold">
                    Handled by:
                </span>
                <select className = "form-control inline" value = {curFilter.approver} onChange = {e => {
                    setFilter({...curFilter, approver: e.currentTarget.value.toLowerCase()});
                    setCurrentPage(1);
                }}>
                    <option value = "">Select</option>
                    {usersList.filter(user => user.purchases === "approver").map((user, userIndex) => 
                    <option key = {userIndex} value = {user.value}>
                        {user.label}
                    </option>)}
                </select>
                {
                curFilter.approver !== ""?
                <span style = {{marginLeft: 10}} onClick = {() => {setFilter({...curFilter, approver: ""})}}>❌</span>:
                null
                }
            </div>
            <div className = "m-3">
                <span className = "mr-3 font-weight-bold">Status:</span>
                <select className = "form-control inline" value = {curFilter.status} onChange = {e => {
                    setFilter({...curFilter, status: e.currentTarget.value});
                    setCurrentPage(1);
                }}>
                    <option value = "">Select</option>
                    <option>Submitted</option>
                    <option>Re-Submitted</option>
                    <option>Approved</option>
                    <option>Rejected</option>
                </select>
                {
                curFilter.status?
                <span style = {{marginLeft: 10}} onClick = {() => {setFilter({...curFilter, status: ""})}}>❌</span>:
                null
                }
            </div>
            <div className = "mt-5 mb-3">
                <span className = "btn btn-secondary" onClick = {() => {
                    setFilter(defaultFilter);
                    setCurrentPage(1);
                }}>Clear Filter</span>
            </div>
        </Modal>
    )
}